import React from 'react';

export const AppContext = React.createContext({
  headerTitle: '',
  hideSideBar: false,
  isEmbeddedMode: false,
  setHeaderTitle: (title: string) => {},
  setHideSideBar: (hide: boolean) => {},
  setSubHeader: ({ slugs, breadcrumbList }) => {},
  breadcrumbList: [],
  slugs: [],
  currentSlug: '',
  setCurrentSlug: (slug: string) => {},
  headerRightView: null as React.ReactNode,
  setHeaderRightView: (node: React.ReactNode) => {},
  mode: 'light',
});
